import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../lib/auth-context.js";
import { usePreferences } from "../../../lib/preferences.js";
import { getNetWorth } from "../../../lib/api-modules/networth.js";
import { Card } from "../../design-system/index.js";
import { Breakdown } from "../Breakdown.js";

/**
 * Phase 13.5 widget — net-worth breakdown (by account / type / owner).
 */
export function BreakdownWidget() {
  const { user } = useAuth();
  const { privacyMode } = usePreferences();
  const networthQuery = useQuery({
    queryKey: ["networth", "24m"],
    queryFn: () => getNetWorth("24m"),
    enabled: !!user,
  });
  const latest = networthQuery.data?.latest ?? null;
  if (!latest) return null;

  return (
    <Card className="mb-6">
      <p className="mb-3 text-xs font-medium uppercase tracking-wide text-[var(--color-muted)]">
        Breakdown
      </p>
      <Breakdown snapshot={latest} hideValues={privacyMode} />
    </Card>
  );
}
